/**
 * The props every text-like field shares (spec-widget-mcp 05 Step 6): `label` is a real `<label>`
 * (MUI binds it to the input by `id`) and the accessible name — `placeholder` never replaces it;
 * `hint` is helper text, replaced by the error when there is one (MUI wires `aria-describedby` and
 * `aria-invalid`). No `<form>` wraps a widget, so `required` never triggers a browser popup.
 */
export const FIELD_SX = {
	"& .MuiOutlinedInput-root": { borderRadius: "8px", fontSize: 13, background: "var(--w-surface)" },
	"& .MuiOutlinedInput-root.Mui-focused fieldset": { borderColor: "var(--w-accent)" },
	"& .MuiInputLabel-root": { fontSize: 13, color: "var(--w-text)" },
	"& .MuiInputLabel-root.Mui-focused": { color: "var(--w-text)" },
	"& .MuiFormHelperText-root": { fontSize: 11.5, mx: 0, color: "var(--w-text)" },
	"& .MuiFormHelperText-root.Mui-error, & .MuiInputLabel-root.Mui-error": { color: "var(--w-error)" },
};

/** `{ id, field, value, error, onChange, onBlur }` → the MUI TextField props they map to. */
export function textFieldProps({ id, field, value, error, onChange, onBlur }) {
	return {
		id,
		fullWidth: true,
		size: "small",
		label: field.label,
		required: field.required === true,
		value: value ?? "",
		placeholder: field.placeholder || undefined,
		error: !!error,
		helperText: error || field.hint || undefined,
		onChange: (e) => onChange(e.target.value),
		onBlur,
		sx: FIELD_SX,
	};
}
